import React, { useRef, useLayoutEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";

function chunkArray(array, chunkSize) {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
}

export default function StatCardsRow({ children }) {
  const containerRef = useRef(null);
  const [cardsPerRow, setCardsPerRow] = useState(3);
  const [overflowMap, setOverflowMap] = useState([]);

  const tryLayouts = useCallback(() => {
    setOverflowMap([]);
    setCardsPerRow(3);
  }, []);

  useLayoutEffect(() => {
    const handleResize = () => {
      tryLayouts();
    };
    if (containerRef.current) {
      const ro = new window.ResizeObserver(handleResize);
      ro.observe(containerRef.current);
      return () => ro.disconnect();
    }
  }, [tryLayouts]);

  const handleOverflow = (idx, isOverflowing) => {
    setOverflowMap(prev => {
      const updated = [...prev];
      updated[idx] = isOverflowing;
      return updated;
    });
  };

  useLayoutEffect(() => {
    if (overflowMap.length === React.Children.count(children)) {
      if (cardsPerRow === 3 && overflowMap.some(x => x)) {
        setCardsPerRow(2);
        setOverflowMap([]); 
      } else if (cardsPerRow === 2 && overflowMap.some(x => x)) {
        setCardsPerRow(1);
        setOverflowMap([]); 
      }
    }
  }, [overflowMap, children, cardsPerRow]);

  const grouped = chunkArray(
    React.Children.map(children, (child, idx) =>
      React.cloneElement(child, {
        key: idx,
        onOverflow: isOverflowing => handleOverflow(idx, isOverflowing),
        sx: {
          flex: `1 1 0`,
          minWidth: 0,
          maxWidth: '100%',
          width: '100%',
          ...child.props.sx,
        }
      })
    ),
    cardsPerRow
  );

  return (
    <Box ref={containerRef} sx={{ width: "100%", mb: 3 }}>
      {grouped.map((row, i) => (
        <Box
          key={i}
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            gap: 2,
            mb: i < grouped.length - 1 ? 2 : 0,
            width: "100%",
            justifyContent: "center",
          }}
        >
          {row}
        </Box>
      ))}
    </Box>
  );
}